import TopMenu from '../components/TopMenu';
import BottomMenu from '../components/BottomMenu';
import { Row, Col, Container, Image } from 'react-bootstrap';
import httlogo from '../images/httcrop.png';
import i1 from '../images/isuzu/Trk-resize.jpg';
function Isuzu() {
    return (
        <div>
            <Image
                    src={httlogo}
                    alt="background"
                    style={{
                        top: 0,
                        left: window.innerWidth < 768 ? '110px' : '30px',
                        height: '75px',
                    }}
                />
            <TopMenu />
            <Container>
                <h2 className='htitleb text-center'>Isuzu</h2>
                <div id="truck-box">
                    <Row>
                        <Col md={6}>
                            <Image
                                src={i1}
                                width={'100%'}
                                fluid
                                rounded
                            />
                        </Col>
                        <Col>
                            <p>“America’s #1 Selling Low Cab Forward every year since 1986” </p>
                            <ul>
                                <li>Versatile to meet any of your vocational needs including: food service, landscaping, light construction, pest control, plumbing or towing</li>
                                <li>Panoramic visibility</li>
                                <li>Excellent handling and maneuverability</li>
                                <li>Ease of maintenance</li>
                                <li>High driver satisfaction and productivity</li>
                                <li>Dependability and low cost of ownership</li>
                            </ul>
                        </Col>
                    </Row>
                </div>
                <br />
            </Container >
            <BottomMenu />
        </div >
    );
}

export default Isuzu;